import { TableCellProps } from '@mui/material';

const FIXED_CELL_SX: TableCellProps['sx'] = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

/** Returns header/cell props that pin a column to a fixed percentage width. */
export function fixedWidthColumnProps(width: string) {
  const sx = { ...FIXED_CELL_SX, width };
  return {
    headerProps: { sx },
    cellProps: () => ({ sx }),
  };
}
